import React from 'react'
import { Box, Drawer, Typography } from '@material-ui/core'
import { ListIcon } from '~/assets/icons'
import { mutualTheme } from '~/utils/theme'
import { useIsMobileScreen, useModal } from '~/hooks'
import { InstallmentsModal, InstallmentsTable } from './components'

export type Installment = {
  installmentNumber: number,
  dueDate: Date,
  installmentValue: number
}

export type InstallmentsTableContainerProps = {
  installments: Installment[]
}

export const InstallmentsTableContainer: React.FC<InstallmentsTableContainerProps> = (props) => {
  const { installments } = props
  const isMobile = useIsMobileScreen()
  const [isModalOpen, toggleModal] = useModal()

  const getFirstInstallments = (installments: Installment[]) => {
    return installments.slice(0, Math.min(installments.length, 3))
  }
  const getLastInstallments = (installments: Installment[]) => {
    return installments.slice(Math.min(installments.length, 3) * -1)
  }

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      borderRadius: 1,
      overflow: 'hidden',
      boxShadow: '2px 2px 8px rgba(0, 0, 0, 0.08)',
      backgroundColor: 'common.white'
    }}>
      <Box sx={{
        display: 'flex',
        flexDirection: 'row'
      }}>
        <InstallmentsTable
          installments={getFirstInstallments(installments)}
          numberOfInstallments={installments.length}
          boldIndex={0}
        />
        {!isMobile && (
          <InstallmentsTable
            installments={getLastInstallments(installments)}
            numberOfInstallments={installments.length}
            boldIndex={Math.min(installments.length - 1, 2)}
          />
        )}
      </Box>
      <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        height: 72,
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 24px',
        backgroundColor: mutualTheme.palette.grey[100]
      }}>
        <Typography variant='airbnbBody1'>
          {`Exibindo ${isMobile ? 3 : 6} de ${installments.length} parcelas`}
        </Typography>
        <Typography
          variant='airbnbBody1'
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: 'secondary.main',
            fontWeight: '700',
            cursor: 'pointer',
            gap: 1
          }}
          onClick={toggleModal}
        >
          <ListIcon />
          Ver todas as parcelas
        </Typography>
      </Box>
      <Drawer open={isModalOpen} onClose={toggleModal} anchor='right'>
        <InstallmentsModal installments={installments} toggleModal={toggleModal} />
      </Drawer>
    </Box>
  )
}
